var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('case-form',{staticClass:"mt6",attrs:{"schema":_vm.schemaShared}}),_c('case-form',{staticClass:"mt6",attrs:{"schema":_vm.schemaLiabilities}}),_c('case-form',{staticClass:"mt6",attrs:{"schema":_vm.schemaExtra}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }